import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadUser } from './user.actions';
import { Injectable, inject } from "@angular/core";
import * as UserActions from './user.actions';
import Keycloak from 'keycloak-js';
import { mergeMap, map, catchError, of, from, timer, switchMap, first, tap, timeout, throwError } from 'rxjs';
import { User } from './user.model';

interface KeycloakResourceAccess {
  roles?: string[];
}

@Injectable()
export class UserEffects {
  private keycloak = inject(Keycloak);

  loadUser$ = createEffect(() => this.actions$.pipe(
    ofType(UserActions.loadUser),
    mergeMap(() => {
      // Use delay to give Keycloak time to initialize
      return timer(100).pipe(
        switchMap(() => from(this.keycloak.loadUserProfile())),
        map(profile => {
          // Get roles from token - combine realm and resource roles
          const realmRoles = this.keycloak.tokenParsed?.realm_access?.roles || [];
          const resourceRoles = Object.values(this.keycloak.tokenParsed?.resource_access || {} as Record<string, KeycloakResourceAccess>)
            .flatMap((access) => access.roles || []);
          const roles = [...realmRoles, ...resourceRoles];
          const tokenParsed = this.keycloak.tokenParsed;

          const user = new User(profile, roles, tokenParsed);
          return UserActions.loadUserSuccess({ user });
        }),
        catchError(error => of(UserActions.loadUserFailure({ error })))
      );
    })
  ));

  constructor(
    private actions$: Actions
  ) {}
}
